window.onWizzyScriptLoaded = function () {
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function (payload) {
        payload.autocomplete.menu.alignment = "right";
      
   //var defaultConfig = JSON.parse('{"suggestions":{"enabled": false,"displayRecent": false,"displayTrending":false,"defaultPool":[{"value":"New Arrivals","valueHighlighted":"New Arrivals","filters":{"categories":["latest-arrivals-new"]},"payload":[],"section":"categories"},{"value":"Gifts Under 500","valueHighlighted":"Gifts Under 500","filters":{"categories":["gifts-under-500-rakhi-2021"]},"payload":[],"section":"categories"},{"value":"Bestsellers in Home","valueHighlighted":"Bestsellers in Home","filters":{"categories":["latest-arrivals-new"]},"payload":[],"section":"categories"},{"value":"Gifts for Boyfriend","valueHighlighted":"Gifts for Boyfriend","filters":{"categories":["gifts-for-boyfriend-husband"]},"payload":[],"section":"categories"},{"value":"Home Hacks","valueHighlighted":"Home Hacks","filters":{"categories":["home-hacks"]},"payload":[],"section":"categories"},{"value":"Organisers","valueHighlighted":"Organisers","filters":{"categories":["latest-arrivals-new"]},"payload":[],"section":"categories"}]},"topProducts":{"enabled": true,"displayRecent": false,"displayTrending":false,"defaultPool":{"method":"filters","expiry":"session","data":{"productsCount":6,"categories": ["263155318819"]}}}}');
   //var noProductsFound = JSON.parse('{"showProducts": true,"defaultPool":{"method":"filters","expiry":"session","data":{"productsCount":6,"categories": ["263155318819"]}}}');
   //payload['autocomplete']['configs']['defaultBehaviour'] = defaultConfig;
   // payload['search']['configs'] = {"showProducts": false};
       window.wizzyConfig.pageStore.groupedFilteredProducts = {}
        return payload;
    })
    let newAutoComplete = document.getElementById("wizzy-autocomplete-top-products-new").text;
    let oldAutoComplete = document.getElementById("wizzy-autocomplete-topproducts");
    oldAutoComplete.text = newAutoComplete;

    let newAutoCompleteWrapper = document.getElementById("wizzy-autocomplete-wrapper-new").text;
    let oldAutoCompleteWrapper = document.getElementById("wizzy-autocomplete-wrapper");
    oldAutoCompleteWrapper.text = newAutoCompleteWrapper;

    let newDiv = document.getElementById("wizzy-search-results-product-new").text;
    let oldDiv = document.getElementById("wizzy-search-results-product")
    oldDiv.text = newDiv;


    let newWizzySearchResults = document.getElementById("wizzy-search-wrapper-new").text;
    let oldWizzySearchResults = document.getElementById("wizzy-search-wrapper")
    oldWizzySearchResults.text = newWizzySearchResults;

  let newWizzyAutocompleteSuggestions = document.getElementById("wizzy-autocomplete-suggestions-new").text;
  let oldWizzyAutocompleteSuggestions = document.getElementById("wizzy-autocomplete-suggestions")
    oldWizzyAutocompleteSuggestions.text = newWizzyAutocompleteSuggestions;

    let newWizzyEmptySearchResults = document.getElementById("wizzy-search-empty-results-new").text;
  let oldWizzyEmptySearchResults = document.getElementById("wizzy-search-empty-results")
    oldWizzyEmptySearchResults.text = newWizzyEmptySearchResults;



  

    let $ = jQuery;
    $(document).ready(function () {

        $("body").on("click", ".wizzy-search-glass,.wizzy-search-back .wizzy-icon", (e) => {
            $('#wizzy-search-input').toggleClass("hide");
        })
    })

       window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED, function (payload) {
  
         let url = window.location.href
         var url1 = new URL(url);
         var q = url1.searchParams.get("q");
         blogPostLoadOnEmptyResults(q)
  
      return payload;
    });

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED, function (payload) {
     console.log("BEFORE_AUTOCOMPLETE_EXECUTED",payload);
     payload.minQueryLength = 1;
     // payload.displayNoResults = true;
     // payload.isForEmptyResult = true;
      return payload;
    });


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function (payload) {
     console.log("BEFORE_AUTOCOMPLETE_RENDER",payload);
    payload.isForDefault = false;
      payload.payload.categories = [{"valueHighlighted": "a", "value": "a"}]
      const checkAll = payload.payload;
      if(checkAll && typeof checkAll.categories !== "undefined"){
        console.log(checkAll);
        if( checkAll.categories.length==0){
           payload.payload.categories = [{"valueHighlighted": "a", "value": "a"}];
        }
      }

    var autocompleteListS = document.querySelector('.autocomplete-suggestions-list-new');
    if (autocompleteListS) {
          var liItemsS = autocompleteListS.querySelectorAll('li');
          if (liItemsS.length === 2) { 
              var aTagS = liItemsS[1].querySelector('a');
              if (aTagS && aTagS.getAttribute('data-searchterm') === 'a') {
                  autocompleteListS.style.display = 'none';
              }
          }
      }
    
      return payload;
    });
  
  
   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function (payload) {
     if(payload.data.api === 'search' || payload.data.api === "filter"){
       blogPostLoad(payload.data.response.payload.filters.q, "search",payload.data.response.payload.total); 
     }

     if(payload.data.api === 'autocomplete'){
       blogPostLoad(payload.data.response.payload.products.filters.q, "autocomplete", payload.data.response.payload.products.total)
     }

      var autocompleteList = document.querySelector('.autocomplete-suggestions-list-new');
      if (autocompleteList) {
            var liItems = autocompleteList.querySelectorAll('li');
            if (liItems.length === 2) { 
                var aTag = liItems[1].querySelector('a');
                if (aTag && aTag.getAttribute('data-searchterm') === 'a') {
                    autocompleteList.style.display = 'none';
                }
            }
        }
       
     return payload;
    });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function (payload) {
     if(payload.length === 0){
     }
        payload.forEach((item) => {
            if (!item.groupId) {
                item.groupId = item.id;
            }
            item.attributes.forEach((attr) => {
                if (attr.id === "product_variant_ids") {
                    item.id = attr.values[0].value[0];
                }
            })
        })
        return payload;
    });
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED, function (payload) {
        $('body').on('click','.t4s-pr-wishlist',function(){
            $('a.is--added').parent().css({'background' : '#3a643b','color' : 'white'});
        })
      });
}

let $ = jQuery;
$(document).ready(function () {
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function (payload) {
        $(".wizzy-search-back")[0].click();
        return payload;
    });
})

if ($(window).width() <= 768) {
    $("#wizzy-search-input").css("display", "none");
} 


function blogPostLoad(q,task,count) {
    $.ajax({
        type: 'GET',
        url: `https://amrutam.co.in/search?q=${q}&type=article,page&section_id=search-main-others`,
        data: {q : q, type:'article,page', section_id:'search-main-others'},
        success: function (response) {
        if(task === 'search' && count){
                      $('#wizzy-search-blogs').html(response);
            $('#wizzy-search-blogs .t4s-result-main__item').each(function(i,element) {
              if(i>=6){
                $(element).remove();
              }
            })
        }
        if(task === 'autocomplete' && count){
            $('#wizzy-autocomplete-blogs').html(response);
            $('#wizzy-autocomplete-blogs .t4s-result-main-title').removeClass('t4s-result-main-title').html('<div class="wizzy-autocomplete-blog-head">BLOGS / PAGES </div>')
            $('#wizzy-autocomplete-blogs .t4s-result-main-image').css('display','none')
            $('#wizzy-autocomplete-blogs .t4s-result-main__item-content').css('display','none')
            $('#wizzy-autocomplete-blogs .t4s-result-main__item').css({'padding-left':'15px'})
            $('#wizzy-autocomplete-blogs .t4s-result-main__item').each(function(i,element) {
              if(i>=6){
                $(element).remove();
              }
            })
        }

        if(task === 'autocomplete' && count === 0){
            $('#wizzy-autocomplete-blogs').html("<p>We couldn't find any matching products!</p>")
            $('#wizzy-autocomplete-blogs').append(response);
            $('#wizzy-autocomplete-blogs .t4s-result-main-title').removeClass('t4s-result-main-title').html('<div class="wizzy-autocomplete-blog-head">BLOGS / PAGES </div>')
            $('#wizzy-autocomplete-blogs .t4s-result-main-image').css('display','none')
            $('#wizzy-autocomplete-blogs .t4s-result-main__item-content').css('display','none')
            $('#wizzy-autocomplete-blogs .t4s-result-main__item').css({'padding-left':'15px'})
            $('.wizzy-autocomplete-suggestions').css({'display':'block'})
            $('#wizzy-autocomplete-blogs .t4s-result-main__item').each(function(i,element) {

              if(i>=6){
                $(element).remove();
              }
            })

        }

      // if(task === 'search' && count === 0){
      //     alert("here");
      //       $('.').html(response);
      //       $('.autocomplete-no-results .t4s-result-main-title').removeClass('t4s-result-main-title').html('<div class="wizzy-autocomplete-blog-head">BLOGS / PAGES </div>')
      //       $('.autocomplete-no-results .t4s-result-main-image').css('display','none')
      //       $('.autocomplete-no-results .t4s-result-main__item-content').css('display','none')
      //       $('.autocomplete-no-results .t4s-result-main__item').css({'padding-left':'15px'})
      //       $('.wizzy-autocomplete-suggestions').css({'display':'block'})
      //       $('.autocomplete-no-results .t4s-result-main__item').each(function(i,element) {
      //         // console.log(i,element);
      //         if(i>=6){
      //           $(element).remove();
      //         }
      //       })

      //   }
          // if(count===0){
          // $('.wizzy-search-empty-results-wrapper').html('<h1>Hello</h1>') 
          // }
document.getElementsByClassName('wizzy-autocomplete-wrapper')[0].scrollIntoView(true);
  // document.getElementsByClassName('wizzy-autocomplete-wrapper')[0].scrollTop = 0;
// document.getElementsByClassName('wizzy-autocomplete-wrapper')[0].scrollTop(0);
    // $('.wizzy-autocomplete-wrapper').scrollTop(0);
          $('.wizzy-autocomplete-wrapper').animate({
             scrollTop:-1000
          })
          

        },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(xhr.status);
        alert(thrownError);
      }
    });
 
  return false;

}


function blogPostLoadOnEmptyResults(q) {
    $.ajax({
        type: 'GET',
        url: `https://amrutam.co.in/search?q=${q}&type=article,page&section_id=search-main-others`,
        data: {q : q, type:'article,page', section_id:'search-main-others'},
        success: function (response) {
           $('#wizzy-search-blogs').html(response);
            $('#wizzy-search-blogs .t4s-result-main__item').each(function(i,element) {
              // console.log(i,element);
              if(i>=6){
                $(element).remove();
              }
            })
        
        },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(xhr.status);
        alert(thrownError);
      }
    });
 
  return false;

}

function removeZeroResultClassesFromAutoComplete(){

  // $('.wizzy-autocomplete-wrapper').removeClass('withoutTopProducts')
}
